var React = require('react');

function NotificationActive (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd"},[React.createElement("g",{"key":0},[React.createElement("path",{"fill":"#242D3F","d":"M10 20c1.1 0 2-.9 2-2H8c0 1.1.9 2 2 2zm6-6V9c0-3.07-1.63-5.64-4.5-6.32V2c0-.83-.67-1.5-1.5-1.5S8.5 1.17 8.5 2v.68C5.64 3.36 4 5.92 4 9v5l-2 2v1h16v-1l-2-2zm-2 1H6V9c0-2.48 1.51-4.5 4-4.5s4 2.02 4 4.5v6z","transform":"translate(2 2)","key":0}),React.createElement("path",{"fill":"#47AA42","d":"M4.15.65l1.43 1.43C3.48 3.567 2.173 5.93 2.03 8.5h-2C.17 5.3 1.75 2.48 4.15.65zm11.7 0c2.39 1.83 3.97 4.65 4.12 7.85h-2c-.148-2.565-1.45-4.926-3.54-6.42z","transform":"translate(2 2)","key":1})]),React.createElement("path",{"fillRule":"nonzero","d":"M0 0H24V24H0z","key":1})]));
}

NotificationActive.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = NotificationActive;

NotificationActive.default = NotificationActive;
